<template>
  <v-card
    class="mx-auto"
    flat
    outlined
  >
    <v-layout
      wrap
    >
      <v-flex xs12 sm4 md2 class="top-border">
        <v-img
          height="130"
          width="130"
          class="my-1 mx-auto"
          :src="item.thumbnailImageUrl"
        ></v-img>
      </v-flex>
      <v-flex xs12 sm8 md7 class="middle-box top-border">
      	<div class="px-1 py-2 middle-box-top">{{item.amazon_title}}</div>
      	<v-layout wrap class="middle-box-bottom">
      		<v-flex md4 class=" flex-column middle-box-bottom-1">
      			<a :href="item.amazon" target="_blank">Amazon</a>
      			<div v-if="item.quantity > 1">(Pack of {{item.quantity}})</div>
      		</v-flex>
      		<v-flex md3 class="middle-box-bottom-2">
      			<a :href="item.product_link" target="_blank">Walmart</a>
      		</v-flex>
      		<v-flex md5 class="flex-column middle-box-bottom-3" :style="{ backgroundColor: stock_background(item) }">
      			{{item.status}} - Aisle{{item.aisles}}
      			<div v-if="item.quantity > 1" class="double-check-text">Double check profits due to multipack</div>
      		</v-flex>
      		</div>
      	</v-layout>
      </v-flex>
      <v-flex xs12 sm12 md3 class="px-2 py-2 top-border text-center text-md-left">
    		<div><label class="details-label">Current Rank:</label> {{item.amazon_rank}}</div>
    		<div><label class="details-label">Walmart Price:</label> {{item.unit_price}}</div>
    		<div><label class="details-label">Amazon Price:</label> {{item.unit_price_2}}</div>
    		<div><label class="details-label">Profit:</label> {{item.net_profit}} ({{item.roi}})</div>
    		<div><label class="details-label">UPC:</label> {{item.upc}}</div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
	props: ['item'],
  data () {
    return {
      
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    stock_background(item){
    	if(item.status == 'In Stock')
    		return '#5cd63559';
    	else if(item.status == 'Limited Stock')
    		return '#d0a711a1';
    	else
    		return '#d0111173';
    }
  }
};
</script>
